import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { MotivoPerdaVendaSelectComponent } from './motivo-perda-venda-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MotivoPerdaVendaSelectComponent
    ],
    exports: [
        MotivoPerdaVendaSelectComponent
    ]
})
export class MotivoPerdaVendaSelectModule { }
